import { PROGRESS_BAR_END, PROGRESS_BAR_START } from './constants';

export function startProgress() {
  return {
    type: PROGRESS_BAR_START,
  };
}

export function endProgress() {
  return {
    type: PROGRESS_BAR_END,
  };
}



// WEBPACK FOOTER //
// ./app/containers/ProgressBar/actions.js